var queryKeys = {
    privacyPolicy: "statements-policies",
    featureFlags: "statements-feature-flags",
    pdfToken: "statement-token",
    insertPdfToken: "statement-insert-token",
};
export default queryKeys;
